import {useState} from 'react'
import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import {CorporationSector} from './CorporationSector'
import {ExportSector} from './ExportSector'
import {RetailSector} from './RetailSector'
import {useAppSelector} from '../../../../redux/hooks'
import {appSelector} from '../../../../redux/slices/appSlices'
import {OrderInfo} from './OrderInfo'

const Divider = styled.div`
  border-bottom: 1px dashed #dcdcdc;
  margin-bottom: 1rem;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

export const FormDetailSIP = () => {
  const {t} = useTranslation()
  const {orderSubDetail: detail, beforeAmandement} = useAppSelector(appSelector)
  const [showBeforeAfter, setShowBeforeAfter] = useState(!beforeAmandement ? false : true)

  return (
    <>
      <Header>
        <OrderInfo />

        <Form.Check
          type='switch'
          id='before-after-order-detail-sip'
          label={t('FormDetailSIP.SWITCH_LABEL')}
          checked={showBeforeAfter}
          onChange={() => setShowBeforeAfter(!showBeforeAfter)}
          disabled={!beforeAmandement}
        />
      </Header>

      <Divider />

      {detail?.sector?.id === 1 && <CorporationSector showBeforeAfter={showBeforeAfter} />}

      {detail?.sector?.id === 2 && <RetailSector showBeforeAfter={showBeforeAfter} />}

      {detail?.sector?.id === 3 && <ExportSector showBeforeAfter={showBeforeAfter} />}
    </>
  )
}
